import template from './lenderAndProduct.template.html';
import templateSearch from '../lender/searchWarning.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    searchFields: '<',
    quickQuoteAssetDetails: '<',
    assetDetails: '<',
    quickQuoteFinanceProposal: '<',
    compareProducts: '<',
    contacts: '<',
    expenses: '<',
    assets: '<',
    liabilities: '<',
    lenders: '<',
    documents: '<',
    idTicket: '<',
    isUnsecured: '<',
    isCommercial: '<',
    isTicketSettled: '<',
    onShow: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      $mdDialog,
      $timeout,
      eventService,
      helperService,
      assetFinanceService,
      AssetFinanceSearchProduct,
      AssetFinanceCompareProduct,
      Product,
      financesService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.chosenProducts = [];
      ctrl.availableAssetTypes = [];
      ctrl.availableTermInMonths = [];
      ctrl.availableSearchAssetAges = [];
      ctrl.availableProductTypes = [];
      ctrl.availableVendorTypes = [];
      ctrl.availableLoanTypes = [];
      ctrl.availableElapsedTimeFromPayout = [];
      ctrl.availableElapsedTermOldLoan = [];
      ctrl.availableIncreaseInRepayment = [];
      ctrl.availableAssetFinanceEmploymentBasis = [];
      ctrl.availableCreditHistories = [];
      ctrl.availableAbnRegistered = [];
      ctrl.availableGstRegistered = [];
      ctrl.availableHomeOwnership = [];
      ctrl.availableTimeAtCurrentAddress = [];
      ctrl.availableTimeInEmployment = [];
      ctrl.availableBankrupts = [];
      ctrl.availableFinancialDefaults = [];
      ctrl.availableUtilityAndTelCo = [];
      ctrl.availablePayDayEnquires = [];
      ctrl.availablePayDayOnStatements = [];
      ctrl.availableDepositRequired = [];
      ctrl.availableYesNoOption = [];
      ctrl.availableProducts = [];
      ctrl.products = [];
      ctrl.searchStarted = false;
      ctrl.showSearchResult = false;
      ctrl.isLoadingFinished = false;
      ctrl.showSearch = true;
      ctrl.isProcessing = true;
      ctrl.showCovid19Info = true;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.availableTermInMonths = helperService.getAvailableTermInMonths({
          isRegular: false
        });
        ctrl.availableSearchAssetAges = assetFinanceService.getAvailableSearchAssetAges();
        ctrl.availableElapsedTimeFromPayout = assetFinanceService.getAvailableElapsedTimeFromPayout();
        ctrl.availableElapsedTermOldLoan = assetFinanceService.getAvailableElapsedTermOldLoan();
        ctrl.availableIncreaseInRepayment = assetFinanceService.getAvailableIncreaseInRepayment();
        ctrl.availableAssetFinanceEmploymentBasis = assetFinanceService.getAvailableAssetFinanceEmploymentBasis();
        ctrl.availableAbnRegistered = assetFinanceService.getAvailableAbnRegistered();
        ctrl.availableGstRegistered = assetFinanceService.getAvailableGstRegistered();
        ctrl.availableHomeOwnership = assetFinanceService.getAvailableHomeOwnership();
        ctrl.availableTimeAtCurrentAddress = assetFinanceService.getAvailableTimeAtCurrentAddress();
        ctrl.availableTimeInEmployment = assetFinanceService.getAvailableTimeInEmployment();
        ctrl.availableBankrupts = assetFinanceService.getAvailableBankrupts();
        ctrl.availableFinancialDefaults = assetFinanceService.getAvailableFinancialDefaults();
        ctrl.availableUtilityAndTelCo = assetFinanceService.getAvailableUtilityAndTelCo();
        ctrl.availablePayDayEnquires = assetFinanceService.getAvailablePayDayEnquires();
        ctrl.availablePayDayOnStatements = assetFinanceService.getAvailablePayDayOnStatements();
        ctrl.availableDepositRequired = assetFinanceService.getAvailableDepositRequired();
        ctrl.availableMaxNegativeEquity = assetFinanceService.getAvailableMaxNegativeEquity();
        ctrl.availableYesNoOption = assetFinanceService.getAvailableYesNoOption();
        ctrl.searchFields = ctrl.searchFields || AssetFinanceSearchProduct.Blank();
        ctrl.quickQuoteAssetDetails = ctrl.quickQuoteAssetDetails || [];
        ctrl.assetDetails = ctrl.assetDetails || [];
        ctrl.quickQuoteFinanceProposal = ctrl.quickQuoteFinanceProposal || {};
        ctrl.compareProducts = ctrl.compareProducts || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.personContacts = _.filter(ctrl.contacts, (c) => !c?.isCompany);
        ctrl.companyContacts = _.filter(ctrl.contacts, (c) => c?.isCompany);
        ctrl.expenses = _.filter(ctrl.expenses || [], (e) => e?.id && _.isUuid(e?.id));
        ctrl.assets = ctrl.assets || [];
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.lenders = _.chain(ctrl.lenders).sortNatural('name').value();
        ctrl.documents = ctrl.documents || [];
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isUnsecured = ctrl.isUnsecured || false;
        ctrl.isCommercial = ctrl.isCommercial || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.setAvailableProductTypes();
        ctrl.availableCreditHistories = assetFinanceService.getAvailableCreditHistories(
          ctrl.isCommercial
        );
        ctrl.availableAssetTypes = assetFinanceService.getAvailableAssetTypes(
          ctrl.isCommercial,
          true
        );
        ctrl.availableLoanTypes = assetFinanceService.getAvailableLoanTypes(ctrl.isCommercial);
        ctrl.availableVendorTypes = assetFinanceService.getAvailableVendorTypes({
          isSearch: false,
          isCommercial: ctrl.isCommercial
        });
        ctrl.totalAssetCost = _.reduce(
          ctrl.assetDetails,
          (memo, num) => _.add(memo + _.toNumber(num?.cost || 0)),
          0
        );
        ctrl.totalAssetCostInfo = _.reduce(
          ctrl.assetDetails,
          (memo, num) => _.add(memo + _.toNumber(num?.costInfo || 0)),
          0
        );
        if (ctrl.compareProducts?.length > 4 || ctrl.chosenProducts?.length > 4) {
          const pLen = ctrl.compareProducts?.length || 0;
          ctrl.compareProducts = ctrl.compareProducts.splice(pLen - 4, pLen - 1);
          ctrl.chosenProducts = ctrl.chosenProducts.splice(pLen - 4, pLen - 1);
          ctrl.saveLenderAndProduct({ compareProducts: ctrl.compareProducts });
        } else if (
          (ctrl.compareProducts?.length <= 4 || ctrl.chosenProducts?.length <= 4) &&
          !ctrl.isTicketSettled
        ) {
          ctrl.getSetSearch();
        }
        ctrl.isReady = true;
      };

      ctrl.setAvailableProductTypes = () => {
        ctrl.availableProductTypes = assetFinanceService.getAvailableProductTypes({
          isCommercial: ctrl.isCommercial
        });
        const canSelectLease = assetFinanceService.canSelectLease(ctrl.assetDetails);
        for (let i = 0; i < ctrl.availableProductTypes.length; i += 1) {
          if (
            ctrl.availableProductTypes[i].id === 2 ||
            ctrl.availableProductTypes[i].id === 3 ||
            ctrl.availableProductTypes[i].id === 5 ||
            ctrl.availableProductTypes[i].id === 7
          ) {
            ctrl.availableProductTypes[i].isDisabled = !canSelectLease;
          }
        }
      };

      ctrl.getSetSearch = () => {
        let needsToSave = false;
        if (ctrl.compareProducts?.length && !ctrl.chosenProducts.length) {
          for (let c = 0; c < ctrl.compareProducts.length; c += 1) {
            ctrl.chosenProducts.push(Product.Build(ctrl.compareProducts[c].selectedProduct));
          }
        }
        if (ctrl.searchFields?.isNew) {
          const assetDetails = !ctrl.assetDetails.length
            ? ctrl.quickQuoteAssetDetails
            : ctrl.assetDetails;
          const totalLoanAmount = _.reduce(
            assetDetails,
            (memo, num) => _.add(memo, _.toNumber(num?.netCost || 0)),
            0
          );
          let assetAge = -1;
          if (assetDetails?.length) {
            const currentYear = parseInt(moment.utc().startOf('day').year() || 0, 10);
            const buildYear = parseInt(assetDetails[0]?.vehicle?.year || 0, 10);
            if (currentYear && buildYear) {
              assetAge = currentYear <= buildYear ? 0 : currentYear - buildYear;
            }
          }
          let applicantAge = 0;
          const ageOfFistPerson = ctrl.personContacts[0]
            ? moment.utc(ctrl.personContacts[0]?.person?.information?.dateOfBirth, 'X')
            : 0;
          if (ageOfFistPerson) {
            const now = moment.utc();
            applicantAge = now.diff(ageOfFistPerson, 'year');
          }
          const integrationLvr = _.multiply(
            _.divide(totalLoanAmount, ctrl.totalAssetCostInfo),
            100
          );

          const abnRegistered = ctrl.setAbnRegistered();
          const gstRegistered = ctrl.setGstRegistered();
          const homeOwnership = ctrl.setHomeOwnership();
          ctrl.searchFields.loanAmount = totalLoanAmount;
          ctrl.searchFields.assetType = assetDetails[0]?.type || 0;
          ctrl.searchFields.assetAge = assetAge;
          ctrl.searchFields.loanTerm =
            ctrl?.searchFields?.loanTerm === 0
              ? ctrl?.quickQuoteFinanceProposal?.term || 0
              : ctrl?.searchFields?.loanTerm;
          if (!ctrl.isCommercial) {
            ctrl.searchFields.productType = 4;
          } else {
            ctrl.searchFields.productType = !ctrl.searchFields.productType
              ? ctrl?.quickQuoteFinanceProposal?.productType || 0
              : ctrl.searchFields.productType;
          }
          ctrl.searchFields.loanType = !ctrl.isCommercial ? 'FULL_DOC' : '';
          ctrl.searchFields.creditScore =
            !ctrl.isCommercial &&
            !ctrl.searchFields?.creditScore &&
            ctrl.contacts?.length &&
            ctrl.contacts[0]?.creditScore?.length
              ? parseFloat(ctrl.contacts[0]?.creditScore[0]?.score || 0)
              : ctrl.searchFields?.creditScore || 0;
          ctrl.searchFields.vendorType = assetDetails[0]?.vendor?.type || 0;
          ctrl.searchFields.balloonValue = !ctrl.searchFields.balloonValue
            ? ctrl?.quickQuoteFinanceProposal?.balloonValue
            : 0;
          ctrl.searchFields.balloonPercent = !ctrl.searchFields.balloonPercent
            ? ctrl?.quickQuoteFinanceProposal?.balloonPercent
            : 0;
          ctrl.searchFields.brokerCommissionValue =
            ctrl.isCommercial && !ctrl.searchFields.brokerCommissionValue
              ? ctrl?.quickQuoteFinanceProposal?.brokerCommissionValue
              : 0;
          ctrl.searchFields.brokerCommissionPercent =
            ctrl.isCommercial && !ctrl.searchFields.brokerCommissionPercent
              ? ctrl?.quickQuoteFinanceProposal?.brokerCommissionPercent
              : 0;
          ctrl.searchFields.lvrLvt = !ctrl.searchFields.lvrLvt
            ? ctrl?.quickQuoteFinanceProposal?.lvr || 0
            : 0;
          ctrl.searchFields.integrationLvrLvt = !ctrl.searchFields.integrationLvrLvt
            ? integrationLvr
            : 0;
          ctrl.searchFields.abnRegistered = abnRegistered;
          ctrl.searchFields.gstRegistered = gstRegistered;
          ctrl.searchFields.homeOwnership = homeOwnership;
          ctrl.searchFields.applicantAge = applicantAge;
          ctrl.searchFields.isNew = false;
          needsToSave = true;
        }
        if (ctrl.isUnsecured) {
          ctrl.searchFields.assetType = ctrl.isCommercial
            ? ctrl.availableAssetTypes[37].id
            : ctrl.availableAssetTypes[11].id;
          ctrl.searchFields.assetAge = -1;
          ctrl.searchFields.vendorType = 0;
          ctrl.searchFields.balloonValue = 0;
          ctrl.searchFields.balloonPercent = 0;
          ctrl.searchFields.lvrLvt = 0;
          ctrl.searchFields.integrationLvrLvt = 0;
          needsToSave = true;
        }
        if (needsToSave) {
          ctrl.lenderAndProductChanges({
            searchFields: ctrl.searchFields,
            action: 'changeLoanAmount'
          });
        } else {
          ctrl.isProcessing = false;
        }
      };

      ctrl.setAbnRegistered = () => {
        let abnRegistered = -1;
        const company = ctrl.companyContacts[0];
        if (company?.company?.information?.dateOfRegistration) {
          const abnMonths = moment
            .utc()
            .diff(
              moment.utc(company.company.information.dateOfRegistration, 'X').toDate(),
              'months'
            );
          if (abnMonths === 0) {
            abnRegistered = 0;
          } else if (abnMonths > 0 && abnMonths <= 11) {
            abnRegistered = 11;
          } else if (abnMonths >= 12 && abnMonths <= 23) {
            abnRegistered = 12;
          } else if (abnMonths >= 24 && abnMonths <= 35) {
            abnRegistered = 24;
          } else if (abnMonths >= 36 && abnMonths <= 59) {
            abnRegistered = 36;
          } else if (abnMonths >= 60) {
            abnRegistered = 60;
          }
        }
        return abnRegistered;
      };

      ctrl.setGstRegistered = () => {
        let gstRegistered = -1;
        const company = ctrl.companyContacts[0];
        if (!company?.company?.information?.isVatRegistered) {
          gstRegistered = 0;
        } else if (company?.company?.information?.isVatRegistered) {
          let gstMonths = 0;
          if (company?.company?.information?.vatRegisteredDate) {
            gstMonths = moment
              .utc()
              .diff(
                moment.utc(company.company.information.vatRegisteredDate, 'X').toDate(),
                'months'
              );
          }
          if (gstMonths === 0) {
            gstRegistered = 0;
          } else if (gstMonths > 0 && gstMonths <= 11) {
            gstRegistered = 11;
          } else if (gstMonths >= 12 && gstMonths <= 23) {
            gstRegistered = 12;
          } else if (gstMonths >= 24 && gstMonths <= 35) {
            gstRegistered = 24;
          } else if (gstMonths >= 36 && gstMonths <= 59) {
            gstRegistered = 36;
          } else if (gstMonths >= 60) {
            gstRegistered = 60;
          }
        }
        return gstRegistered;
      };

      ctrl.setHomeOwnership = () => {
        let homeOwnership = 'NOT_ESSENTIAL';
        const homeOwnerships = [];
        const assets = _.filter(ctrl.assets, (a) =>
          helperService.isAssetTypeOwnerOccupiedOrInvestment(a.assetType)
        );
        if (assets.length) {
          for (let a = 0; a < assets.length; a += 1) {
            const liabilities = _.filter(ctrl.liabilities, (l) => l.idAsset === assets[a].id);
            const sumBalances = _.reduce(
              liabilities,
              (memo, num) => memo + helperService.isNumber(num.balance, true),
              0
            );
            if (sumBalances > 0) {
              const result = sumBalances / helperService.isNumber(assets[a].value, true);
              homeOwnerships.push(result);
            }
          }
        }
        if (homeOwnerships.length) {
          const maxValue = _.max(homeOwnerships);
          homeOwnership = maxValue <= 80 ? 'OWNER_W_EQUITY_GT_20' : 'OWNER_W_EQUITY_LT_20';
        }
        return homeOwnership;
      };

      ctrl.changeSearchParams = () => {
        ctrl.availableProducts = [];
      };

      ctrl.searchStart = ({ isSearchStarted }) => {
        if (!isSearchStarted) {
          ctrl.changeSearchParams();
          ctrl.searchStarted = true;
          ctrl.showSearchResult = false;
        }

        financesService
          .assetFinanceProductsSearch({
            idTicket: ctrl.idTicket,
            offsetNo: ctrl.availableProducts?.length
          })
          .then((data) => {
            if (data?.status) {
              const products = [];
              for (let p = 0; p < data?.products?.length; p += 1) {
                products.push(Product.Build(data?.products[p]));
              }
              ctrl.availableProducts = ctrl.availableProducts.concat(products);
              if (!isSearchStarted) {
                ctrl.products = [];
                ctrl.showSearchResult = true;
                ctrl.searchStarted = false;
                ctrl.showSearch = false;
              }
              ctrl.isLoadingFinished = products?.length === 100;
              ctrl.products = products;
            } else {
              ctrl.showSearchResult = true;
              ctrl.searchStarted = false;
              ctrl.showSearch = false;
            }
          });
      };

      ctrl.resetSearchProducts = () => {
        ctrl.searchFields = AssetFinanceSearchProduct.Blank();
        ctrl.changeSearchParams();
        ctrl.saveLenderAndProduct({ searchFields: ctrl.searchFields });
      };

      ctrl.searchProducts = ($event) => {
        $event.stopPropagation();
        if (ctrl.chosenProducts.length < 4) {
          ctrl.searchStart({ isSearchStarted: false });
        } else {
          $mdDialog
            .show({
              targetEvent: $event,
              locals: {
                searchFields: ctrl.searchFields
              },
              template: templateSearch,
              controllerAs: '$ctrl',
              controller(searchFields) {
                const ctr = this;
                ctr.searchFields = searchFields;
                ctr.confirm = () => {
                  $mdDialog.hide(ctr.searchFields);
                };
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((result) => {
              ctrl.searchFields = result;
              ctrl.products = [];
              for (let i = 0; i < ctrl.chosenProducts.length; i += 1) {
                ctrl.chosenProducts[i].isSelected = false;
                ctrl.productAdded(ctrl.chosenProducts[i]);
              }
              ctrl.chosenProducts = [];
              ctrl.searchStart({ isSearchStarted: false });
            });
        }
      };

      ctrl.productSelected = (data) => {
        if (data.isSelected) {
          ctrl.chosenProducts.push(data);
        } else {
          const idx = helperService.findIndexById(ctrl.chosenProducts, data.id);
          if (idx > -1) {
            ctrl.chosenProducts.splice(idx, 1);
          }
        }
        ctrl.productAdded(data);
      };

      ctrl.productAdded = (data) => {
        if (data && data.isSelected) {
          const compareProduct = assetFinanceService.addProductToCompare({
            selectedProduct: data
          });
          ctrl.compareProducts.push(compareProduct);
          ctrl.saveLenderAndProduct({ compareProducts: ctrl.compareProducts });
        } else if (data && !data.isSelected) {
          const idx = _.findIndex(
            ctrl.compareProducts,
            (c) => c.selectedProduct.id === data.id
          );
          if (idx > -1) {
            ctrl.compareProducts.splice(idx, 1);
            ctrl.saveLenderAndProduct({ compareProducts: ctrl.compareProducts });
          }
        }
      };

      ctrl.removeProduct = (idProduct) => {
        const idx = _.findIndex(ctrl.chosenProducts, (p) => p.id === idProduct);
        if (idx > -1) {
          ctrl.chosenProducts[idx].isSelected = false;
          ctrl.productAdded(ctrl.chosenProducts[idx]);
          ctrl.chosenProducts.splice(idx, 1);
        }
      };

      ctrl.listProductsReady = (list) => {
        ctrl.productsList = list;
      };

      ctrl.getLender = (idLender) => {
        let lender;
        if (ctrl.lenders.length) {
          lender = ctrl.lenders.find((l) => l.id === idLender);
        }
        return lender;
      };

      ctrl.getLenderDocument = (idLender) => {
        const doc = _.find(
          ctrl.documents || [],
          (d) => d.lender[0]?.id === idLender && d.type.indexOf('LOGO') > -1
        );
        return doc?.url || '';
      };

      ctrl.showSection = () => {
        ctrl.onShow({ section: 'compareProducts' });
      };

      ctrl.showError = () =>
        !ctrl?.searchFields?.idLenders?.length ||
        !ctrl?.searchFields?.loanAmount ||
        !ctrl?.searchFields?.loanTerm ||
        !ctrl?.searchFields?.productType ||
        (ctrl?.searchFields?.productType === 2 &&
          !ctrl?.searchFields?.balloonPercent &&
          !ctrl?.searchFields?.balloonValue) ||
        !ctrl.searchFields.loanType;

      ctrl.showWarning = () => {
        let isANZSelected = false;
        const len = ctrl.lenders.length;
        for (let i = 0; i < len; i += 1) {
          if (!isANZSelected) {
            isANZSelected =
              ctrl?.searchFields?.idLenders.indexOf(ctrl.lenders[i].id) > -1 &&
              ctrl.lenders[i].abbr === 'ANZAF';
          }
        }
        return (
          isANZSelected &&
          (ctrl.searchFields.productType === 2 ||
            ctrl.searchFields.productType === 3 ||
            ctrl.searchFields.productType === 7)
        );
      };

      ctrl.lenderAndProductChanges = ({ action }) => {
        if (!_.isEmpty(ctrl.searchFields)) {
          ctrl.isProcessing = true;
          switch (action) {
            case 'toggleLenders':
              if (ctrl.searchFields?.idLenders?.length) {
                ctrl.searchFields.idLenders = [];
              } else {
                for (let l = 0; l < ctrl.lenders?.length; l += 1) {
                  ctrl.searchFields?.idLenders?.push(ctrl.lenders[l]?.id);
                }
              }
              break;
            case 'changeProductType':
              if (
                ctrl.searchFields?.productType === 5 ||
                ctrl.searchFields?.productType === 6 ||
                ctrl.searchFields?.productType === 7
              ) {
                ctrl.searchFields.balloonPercent = 0;
                ctrl.searchFields.balloonValue = 0;
              }
              break;
            case 'changeLoanAmount':
              ctrl.searchFields.lvrLvt = assetFinanceService.setLvrLvt({
                amount: ctrl.searchFields?.loanAmount || 0,
                total: ctrl?.totalAssetCost || 0
              });
              ctrl.searchFields.integrationLvrLvt = assetFinanceService.setLvrLvt({
                amount: ctrl.searchFields?.loanAmount || 0,
                total: ctrl?.totalAssetCostInfo || 0
              });
              if (ctrl.isCommercial) {
                ctrl.searchFields.brokerCommissionValue =
                  ctrl.searchFields?.loanAmount && ctrl.searchFields?.brokerCommissionPercent
                    ? _.multiply(
                        ctrl.searchFields.loanAmount,
                        _.divide(ctrl.searchFields.brokerCommissionPercent, 100)
                      )
                    : 0;
              }
              break;
            case 'changeBalloonPercent':
              ctrl.searchFields.balloonValue = ctrl.searchFields?.balloonPercent
                ? _.multiply(
                    ctrl.totalAssetCost,
                    _.divide(ctrl.searchFields.balloonPercent, 100)
                  )
                : 0;
              break;
            case 'changeBalloonValue':
              ctrl.searchFields.balloonPercent =
                ctrl.searchFields?.balloonValue && ctrl.totalAssetCost
                  ? _.multiply(
                      _.divide(ctrl.searchFields.balloonValue, ctrl.totalAssetCost),
                      100
                    )
                  : 0;
              break;
            case 'changeBrokerCommissionPercent':
              ctrl.searchFields.brokerCommissionValue =
                ctrl.searchFields?.loanAmount && ctrl.searchFields?.brokerCommissionPercent
                  ? _.multiply(
                      ctrl.searchFields.loanAmount,
                      _.divide(ctrl.searchFields.brokerCommissionPercent, 100)
                    )
                  : 0;
              break;
            case 'changeBrokerCommissionValue':
              ctrl.searchFields.brokerCommissionPercent =
                ctrl.searchFields?.brokerCommissionValue && ctrl.searchFields?.loanAmount
                  ? _.multiply(
                      _.divide(
                        ctrl.searchFields.brokerCommissionValue,
                        ctrl.searchFields.loanAmount
                      ),
                      100
                    )
                  : 0;
              break;
            case 'changeLvrLvt':
              ctrl.searchFields.loanAmount =
                ctrl.searchFields?.lvrLvt && ctrl.totalAssetCost
                  ? _.subtract(
                      _.multiply(_.divide(ctrl.searchFields.lvrLvt, 100), ctrl.totalAssetCost),
                      ctrl.searchFields?.brokerCommissionValue || 0
                    )
                  : 0;
              ctrl.searchFields.integrationLvrLvt = assetFinanceService.setLvrLvt({
                amount: ctrl.searchFields?.loanAmount || 0,
                total: ctrl?.totalAssetCostInfo || 0
              });
              ctrl.searchFields.brokerCommissionValue =
                ctrl.searchFields?.loanAmount && ctrl.searchFields?.brokerCommissionPercent
                  ? _.multiply(
                      ctrl.searchFields.loanAmount,
                      _.divide(ctrl.searchFields.brokerCommissionPercent, 100)
                    )
                  : 0;
              break;
            case 'changeIntegrationLvrLvt':
              ctrl.searchFields.loanAmount =
                ctrl.searchFields?.integrationLvrLvt && ctrl.totalAssetCostInfo
                  ? _.subtract(
                      _.multiply(
                        _.divide(ctrl.searchFields.integrationLvrLvt, 100),
                        ctrl.totalAssetCostInfo
                      ),
                      ctrl.searchFields?.brokerCommissionValue || 0
                    )
                  : 0;
              ctrl.searchFields.lvrLvt = assetFinanceService.setLvrLvt({
                amount: ctrl.searchFields?.loanAmount || 0,
                total: ctrl?.totalAssetCost || 0
              });
              ctrl.searchFields.brokerCommissionValue =
                ctrl.searchFields?.loanAmount && ctrl.searchFields?.brokerCommissionPercent
                  ? _.multiply(
                      ctrl.searchFields.loanAmount,
                      _.divide(ctrl.searchFields.brokerCommissionPercent, 100)
                    )
                  : 0;
              break;
            case 'loanType':
              if (ctrl.searchFields?.loanType !== 'REPLACEMENT_POLICY') {
                ctrl.searchFields.likeForLike = 'NOT_ESSENTIAL';
                ctrl.searchFields.changeToEntityAllowed = 'NOT_ESSENTIAL';
                ctrl.searchFields.elapsedTimeFromPayout = 'NOT_ESSENTIAL';
                ctrl.searchFields.elapsedTermOldLoan = 'NOT_ESSENTIAL';
                ctrl.searchFields.increaseInRepayment = 'NOT_ESSENTIAL';
              }
              break;
            default:
              break;
          }
          ctrl.lPChanges();
        }
      };

      ctrl.lPChanges = _.debounce(() => {
        if (!_.isEmpty(ctrl.searchFields)) {
          ctrl.saveLenderAndProduct({ searchFields: ctrl.searchFields, isChanged: true });
          ctrl.changeSearchParams();
        }
      }, 3000);

      ctrl.saveLenderAndProduct = ({ searchFields, compareProducts, isChanged }) => {
        if (isChanged) {
          ctrl.availableProducts = [];
          ctrl.showSearchResult = false;
        }
        const data = {};
        if (searchFields) {
          data.searchFields = searchFields;
        }
        if (compareProducts) {
          data.compareProducts = compareProducts;
        }
        data.aFCD = 'assetFinanceSearchProducts';
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'assetFinanceSearchProducts') {
          ctrl.isProcessing = false;
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
